export type Verbosity = 'Concise' | 'Normal' | 'Verbose';
export const VERBOSITY_VALUES: Verbosity[] = ['Concise', 'Normal', 'Verbose'];
const STORAGE_KEY = 'kairos.verbosity';

export function loadVerbosity(): Verbosity {
  const v = localStorage.getItem(STORAGE_KEY);
  if (v === 'Concise' || v === 'Normal' || v === 'Verbose') return v;
  return 'Normal';
}

export function saveVerbosity(v: Verbosity): void {
  localStorage.setItem(STORAGE_KEY, v);
}
